import formBaseMixin from  '../../../components/form/form-base-mixin.js'
import {individuals} from "../../../api/api-endpoints"
import {individualsOffline} from "../../../api/api-offline-endpoints"

export default {
  mixins: [formBaseMixin],
  data () {
    return {
      fields: {
        name: '',
        surname: '',
        patronymic: '',
        snils: '',
        date_of_birth: '',
        identity_card_type_id: '',
        identity_card_number: '',
        identity_card_issue_date: '',
        identity_card_series: '',
        accounts: []
      }
    }
  },
  props: {
    parentItem: {
      type: Object
    }
  },
  computed: {
    collections () {
      return this.$store.getters.readUrlEndpoint(
        this.getCollectionEndpoint()
      ) || {}
    },
    identityCardTypes () {
      return this.collections.identity_card_type
    },
    itemId () {
      // когда вставлена внуть друго модалки, котоая внутри модалки
      // https://redmine.etton.ru/issues/15244
      if (this.$route.name.endsWith('create')) {
        return null
      }
      return this.$route.params.id || this.$route.params.objectId || null
    }
  },
  beforeDestroy () {
    // reset
    this.$store.commit('setEndpointData', {
      endpoint: this.accountHolidayDataUrl(),
      data: {
        data: []
      }
    })
  },
  methods: {
    onSuccess () {
      this.$emit('success', {
        fields: this.fields
      })

      formBaseMixin.methods.onSuccess.call(this)
    },
    accountHolidayDataUrl () {
      return individualsOffline.holidaysAccountsTable(this.$route.name)
    },
    prepareFieldsForSend (fields = {}) {
      fields.identity_card_number = fields.identity_card_number.toString()
      fields.identity_card_series = fields.identity_card_series.toString()
      return fields
    },
    transformFieldsBeforeSend () {
      const accounts = this.$store.getters.readUrlEndpoint(
        this.accountHolidayDataUrl()
      )
      if (accounts && accounts.data.length > 0) {
        this.fields.accounts = accounts.data.slice()
      } else {
        this.fields.accounts = []
      }
    },
    individualAccountsEndpoint (ctx) {
      let url = null
      if (this.item && this.item.id) {
        let route = {query: {}}
        if (ctx.currentSort) {
          route.query.sort = ctx.currentSort
        }
        if (ctx.paginateObj && ctx.paginateObj.page) {
          route.query.page = ctx.paginateObj.page
        }
        if (ctx.paginateObj && ctx.paginateObj['per-page']) {
          route.query.page = ctx.paginateObj['per-page']
        }

        url = individuals.individualAccounts(this.item.id, route)
      }
      return {
        url
      }
    },
    update () {
      if (this.item) {
        this.fields = Object.assign({}, {
          date_of_birth: '',
          identity_card_issue_date: '',
          accounts: []
        }, this.item)

        // copy data from item arr to store in offline endpoint
        const accounts = this.item.accounts || []
        // put data to store
        this.$store.commit('setEndpointData', {
          endpoint: this.accountHolidayDataUrl(),
          data: {
            // drop deep link to objects
            data: JSON.parse(JSON.stringify(accounts))
          }
        })
        // and update table
        this.$refs.accountHolidays && this.$refs.accountHolidays.fetchData()
      }
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    if (methods.getCollectionEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getCollectionEndpoint(),
        fromCache: true
      }))
    }

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}

